import template from './booking.html';
import controller from './booking.controller';

const bookingComponent = {
    bindings: {
        data: '<'
    },
    template,
    controller,
    controllerAs: 'vm'
};

export default bookingComponent;



// WEBPACK FOOTER //
// ./client/app/routes/onTheBeach/booking/booking.component.js